// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jr[data-v-4208aaec]{width:100%}.list-tabs[data-v-4208aaec]{z-index:1}.jr__lists[data-v-4208aaec]{position:relative;z-index:0}", ""]);
// Exports
module.exports = exports;
